var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-responsive" }, [
    _c("table", [
      _c("thead", [
        _c("tr", [
          _c("th", [
            _vm._v(
              _vm._s(
                _vm.sts_type === "POR"
                  ? _vm.$t("message.porcentaje")
                  : _vm.$t("message.area")
              )
            )
          ]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("message.valor")))]),
          _vm._v(" "),
          _c("th", [_vm._v("H.M")]),
          _vm._v(" "),
          _c("th", [
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.agregar }
              },
              [_c("i", { staticClass: "fa fa-plus" })]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.areas, function(area, index) {
            return _c("tr-area", {
              key: _vm.moment(new Date()).format("YYYYMMDDHHmmss") + index,
              tag: "tr",
              on: { eliminar: _vm.eliminar },
              model: {
                value: _vm.areas[index],
                callback: function($$v) {
                  _vm.$set(_vm.areas, index, $$v)
                },
                expression: "areas[index]"
              }
            })
          }),
          _vm._v(" "),
          _c(
            "tr",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.areas.length === 0,
                  expression: "areas.length === 0"
                }
              ]
            },
            [
              _c("td", { attrs: { colspan: "4" } }, [
                _c("strong", [_vm._v(_vm._s(_vm.$t("message.sinDatos")))])
              ])
            ]
          )
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-761b4820", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-761b4820","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/sts/TablaAreas.vue
// module id = 388
// module chunks = 0